import { useEffect, useRef } from "react";
import "../styles/home.scss";
import ProfileLinks from "../components/ProfileLinks";
import { useNavigate, Link } from "react-router-dom";
import projects from "../data/projects";
import Designs from '../pages/Designs';

export default function Home() {
  const navigate = useNavigate();
  const spotlightProjects = projects.filter((p) => p.spotlight);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index);
          entry.target.style.animationDelay = `${index * 0.15}s`;

          if (entry.isIntersecting) {
            entry.target.classList.add("fade-up");
          } else {
            entry.target.classList.remove("fade-up");
          }
        });
      },
      { threshold: 0.1 }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <div className="intro">
        <h1>Hi, I'm Van Ma.</h1>
        <p>
          Transforming user insights and data into actionable product decisions 
          and intuitive experiences.
        </p>
        <p className="hero-roles">
          <strong>
            UX Engineer <span className="separator"> · </span> 
            Developer <span className="separator"> · </span> 
            Strategist
          </strong>
        </p>
      </div>

      <ProfileLinks variant="default" aria-label="Profile and contact links" />
      
      {/* Case Studies / Development Projects */}
      <div className="home">
        <section className="home-projects" aria-label="Featured projects">
          <div className="home-project-cards">
            {spotlightProjects.map((project, i) => (
              <div
                key={project.slug}
                className="home-project-card"
                ref={(el) => (cardsRef.current[i] = el)}
                data-index={i}
              >
                <Link
                  to={`/project/${project.slug}`}
                  aria-label={`View project: ${project.name}`}
                >
                  <div className="home-project-container">
                    <div className="home-project-details">
                      <div className="name-icon">
                        <h2 className="home-project-title">{project.name}</h2>
                      </div>

                      <div className="tags" aria-label="Project tags">
                        {project.tags.map((tag, j) => (
                          <span key={j} className="tag">
                            {tag}
                          </span>
                        ))}
                      </div>

                      <p className="home-project-description">
                        {project.description}
                      </p>
                    </div>

                    <div className="img-preview-container">
                      {project.preview && (
                        <img
                          src={project.preview}
                          alt={`${project.name} preview`}
                        />
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Design Gallery Section (Spotlighted only) */}
      <section className="home-designs" aria-label="Featured designs">
        <Designs spotlightOnly={true} />
      </section>

     <button
        type="button"
        className="more-projects"
        onClick={() => navigate("/project")}
        aria-label="View more projects"
      >
        View more projects
      </button>
    </div>
  );
}